/**
 * Look up properties from `window.FLAGS`
 * This will be replaced by a new module called raven-flags in the future.
 * Returns the boolean value of the flag if it exists. If flag doesn't exist,
 * it returns undefined.
 *
 * @param flagName
 * @returns boolean | undefined
 */
export const useWindowFlag = (flagName?: string) => {
  if (flagName && typeof window !== 'undefined' && window.FLAGS) {
    return Boolean(window.FLAGS[flagName]);
  }
  return undefined;
};
